import { useCallback } from 'react';
import { LocalAccount } from '../../../types/LocalAccount';
import { showAlert } from '@silverfort/sf-components';
import { useResumeLocalAccountsProtection } from '../../../api';

interface UseBulkResumeLocalAccountsProtectionParams {
    accounts: LocalAccount[];
    onProtectionResumed?: () => void;
}

interface ReturnType {
    resumeLocalAccountsProtection: () => void;
}

const useBulkResumeLocalAccountsProtection = ({
    accounts,
    onProtectionResumed
}: UseBulkResumeLocalAccountsProtectionParams): ReturnType => {
    const handleProtectionResumed = useCallback(() => {
        showAlert(
            `Protection resumed for ${
                accounts.length > 1 ? accounts.length + ' local accounts' : accounts[0].userName
            }`,
            'success'
        );
        onProtectionResumed?.();
    }, [accounts, onProtectionResumed]);

    const handleError = useCallback(() => {
        showAlert('Failed to resume protection, please try again', 'error');
    }, []);

    const { resumeLocalAccountsProtection } = useResumeLocalAccountsProtection({
        onSuccess: handleProtectionResumed,
        onError: handleError
    });

    const handleResumeProtection = useCallback(() => {
        if (accounts?.length) {
            resumeLocalAccountsProtection(accounts.map(({ guid }) => guid));
        }
    }, [accounts, resumeLocalAccountsProtection]);

    return { resumeLocalAccountsProtection: handleResumeProtection };
};

export default useBulkResumeLocalAccountsProtection;
